 
 
import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { PaginationResult } from "../../../../../Shared/Model/PaginationResult";
import { Brand } from "../../../Domain/Model/Brand";
import BrandDataSource from "../BrandDataSource";
import { BrandAPIEntity } from "./Entity/BrandAPIEntity";

const routeName = `/v1/brand`;
export default class BrandAPIDataSourceImpl implements BrandDataSource {
    
     async createBrand(data: Brand): Promise<BrandAPIEntity[]> {
      try {
        // Define los datos que deseas enviar en la petición POST
        const postData = {
          name: data.name,
          image: data.image,
        };
    
        // Realiza la petición POST utilizando api
        const response = await api.post<ApiResponse<any>>(routeName, postData);
    
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Mapea los datos de la respuesta al formato de CategoryAPIEntity que esperas
          const brands = response.data.data;
    
          return brands;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al agragar la Marca:", error);
        throw new Error("Error al agragar la Marca");
      }
    }

        // async getCustomers(page = 1, pageSize = 10, search: string = ''): Promise<PaginationResult<CustomerAPIEntity>> {

    async getBrands(page = 0, pageSize = 10, search: string = ''): Promise<PaginationResult<BrandAPIEntity>> {
      const SortOrder = "desc";
      try {
        const response = await api.get<ApiResponse<any>>(routeName, {
            params: { page, pageSize, search, SortOrder }
        });
        // console.log(response.data.data);
        const data = response.data.data;
        // Verifica si la respuesta contiene datos
        if (data && Array.isArray(data.items)) {
          // Mapea los datos de la respuesta al formato de Category que esperas
          const brands: BrandAPIEntity[] = data.items.map((item: BrandAPIEntity) => ({
            id: item.id,
            name: item.name,
            image: item.image
          }));
  
          // return brands;
          return {
            items: brands,
            page: data.page,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            hasNextPage: data.hasNextPage,
            hasPreviousPage: data.hasPreviousPage,
          };
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al obtener las Marcas:", error);
        throw new Error("Error al obtener las Marcas");
      }
    }

    async getBrandsList(): Promise<BrandAPIEntity[]> {
      try {
        const response = await api.get<ApiResponse<any>>(routeName);
        // console.log(response.data.data);
        const data = response.data.data;
        // Verifica si la respuesta contiene datos
        if (data && Array.isArray(data)) {
          // Mapea los datos de la respuesta al formato de Category que esperas
          const brands: BrandAPIEntity[] = data.map((item: any) => ({
            id: item.id,
            name: item.name,
            image: item.image
          }));
          return brands;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al obtener las Marcas:", error);
        throw new Error("Error al obtener las Marcas");
      }
    }

    async updateColor(data: Brand): Promise<boolean> {
      try {
        // Realiza la petición PUT utilizando api
        const response = await api.put<ApiResponse<any>>(`${routeName}`, data);
  
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Devuelve true si la actualización fue exitosa
          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al actualizar la marca:", error);
        throw new Error("Error al actualizar la marca");
      }
    }

    async removeColor(id: string): Promise<boolean> {
      try {
        // Realiza la petición DELETE utilizando api
        const response = await api.delete<ApiResponse<any>>(`${routeName}/${id}`);
  
        // Verifica si la respuesta contiene datos
        if (response.data.succeeded === true) {
          // Devuelve true si la eliminación fue exitosa
          return true;
        } else {
          // Maneja el caso en el que la respuesta no tiene el formato esperado
          throw new Error("La respuesta no tiene el formato esperado");
        }
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al eliminar la marca:", error);
        throw new Error("Error al eliminar la marca");
      }
    }

    
  }